// Swap these two URLs once — every CTA and the video player update site-wide.
export const CHECKOUT_URL = "https://buy.stripe.com/00waEX9lV9mCeBFcHl0co0H";
export const VIDEO_URL = "";

export const IMAGES = {
  dasha: "/images/photo-dasha-laptop.png",
  skool: "/images/screenshot-skool-course.png",
  offer: "/images/offer-desk.jpg",
  book: "/images/book-becoming-her.jpg",
};
